import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Eliminar las cookies
        localStorage.removeItem('email');
        localStorage.removeItem('userRoles');
        localStorage.removeItem('authToken');
        
        // Redirigir a la página de inicio de sesión (o cualquier otra página que desees)
        navigate('/');
    }, [navigate]);

    return null; // Puedes regresar null o algún otro contenido si es necesario
}

export default Logout;